module.exports = __webpack_public_path__ + "img/border-center-h.be5a96b0.svg";